import { useNavigate } from 'react-router'

import { Button } from '@paysense-india-services/elevate-web'

import { EXTERNAL_ROUTES, ROUTES } from '@/constants/routes'

import { useProductConfig } from '@/contexts/ProductConfigContext'

import Header from '@/components/Header'
import Logo from '@/components/Logo'
import PageContainer from '@/components/PageContainer'

const LandingPage = () => {
  const navigate = useNavigate()
  const { appendProductParams, getReturnUrl } = useProductConfig()

  return (
    <>
      <Header leftComponent={Logo} />
      <div className="appLayout ew-h-100">
        <PageContainer className="ew-d-flex ew-flex-column ew-justify-content-center ew-align-items-center ew-h-100">
          <div className="ew-d-flex ew-flex-column ew-gap-12 ew-w-100" style={{ maxWidth: 320 }}>
            <Button
              fullWidth
              onClick={() => {
                window.location.href = getReturnUrl() || EXTERNAL_ROUTES.WEBSITE
              }}
              size="medium"
              type="default"
              variant="brand"
            >
              Go to Website
            </Button>
            <Button
              fullWidth
              onClick={() => navigate(`${ROUTES.LOGIN}?${appendProductParams().toString()}`)}
              size="medium"
              type="outline"
              variant="brand"
            >
              Go to Login
            </Button>
          </div>
        </PageContainer>
      </div>
    </>
  )
}

export default LandingPage
